import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '~/style/colors-ts';

export const appBarOverrides: Components<Theme>['MuiAppBar'] = {
    styleOverrides: {
        root: ({theme}) => ({
            backgroundColor: COLORS.white[900],
            borderBottom: `1px solid ${theme.palette.divider}`,
        }),
    },
};
